import React from "react";
import { motion } from "framer-motion";
import { Clock, Salad, Heart, CalendarDays } from "lucide-react";

const BENEFITS = [
  {
    icon: Clock,
    title: "Ahorra tiempo",
    desc: "Menús semanales y listas de compras para organizarte fácil todos los días.",
  },
  {
    icon: Salad,
    title: "Alimentación saludable",
    desc: "Recetas nutritivas que ayudan al crecimiento y desarrollo de tus hijos.",
  },
  {
    icon: Heart,
    title: "Menos estrés diario",
    desc: "Ideas prácticas y variadas para que cocinar deje de ser un problema.",
  },
  {
    icon: CalendarDays,
    title: "Organización total",
    desc: "Todo por edad, desde 0 hasta 15 años, paso a paso y sin complicaciones.",
  },
];

export default function Benefits() {
  return (
    <section
      id="beneficios"
      data-testid="benefits-section"
      className="bg-[#F4EBDE] pb-20 md:pb-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.2 }}
          transition={{ duration: 0.7 }}
          className="bg-[#FBF4E7]/80 backdrop-blur border border-[#E8DDC9] rounded-[2.5rem] p-8 md:p-12 shadow-[0_20px_60px_rgba(78,60,40,0.06)]"
        >
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            {BENEFITS.map((b, i) => (
              <motion.div
                key={b.title}
                data-testid={`benefit-card-${i}`}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, amount: 0.3 }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="flex flex-col items-start gap-4"
              >
                <div className="w-16 h-16 rounded-full bg-[#E5E9DB] flex items-center justify-center shadow-[0_6px_18px_rgba(132,153,131,0.15)]">
                  <b.icon className="h-6 w-6 text-[#6F856E]" strokeWidth={1.6} />
                </div>
                <h3 className="font-serif-display text-2xl text-[#2A302A] leading-tight">
                  {b.title}
                </h3>
                <p className="text-sm leading-relaxed text-[#576057]">{b.desc}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
